<app-sidenav>
  <ng-template #sidenavContent>
    <app-pdf-reactor-header>
      <app-card title="{{ 'content.this-order' | translate }}">
        <app-consumer-credit-report-sidenav [consumerReport]="consumerReport" [consumerRequest]="consumerRequestReport?.req"></app-consumer-credit-report-sidenav>
      </app-card>
    </app-pdf-reactor-header>
  </ng-template>
  <ng-template #mainContent>
    @if (_creditReportRef) {
      <app-pdf-button-bar
        newOrderUrl="/consumer-services"
        [css]="consumerReportCss"
      [documentRootElement]="[_appCard, _creditReportRef]"></app-pdf-button-bar>
      }<!-- [_creditReportRef, _ifsReportRef] -->

      <app-ifs-report-content [ifsReport]="ifsReport"
        [inputData]="consumerRequestReport"
        (creditReport)="creditReportRef = $event"
      (thisOrder)="thisOrder = $event"></app-ifs-report-content>

      @if (_creditReportRef && isAnyHit(consumerReport?.consumers)) {
        <app-pdf-button-bar
          newOrderUrl="/consumer-services"
          [css]="consumerReportCss"
        [documentRootElement]="[_appCard, _creditReportRef]"></app-pdf-button-bar>
      }
    </ng-template>
  </app-sidenav>
